import React, { FunctionComponent } from "react";
import { Typography } from "@bca/ui-library";
import { Variant } from "@bca/ui-library/dist/Typography/typography.type";

interface VersionNavigationSpanProps {
  variant: Variant;
  fontWeight: string;
  children?: React.ReactNode;
}

const VersionNavigationSpan: FunctionComponent<VersionNavigationSpanProps> = ({
  variant,
  fontWeight,
  children,
}) => {
  return (
    <>
      <Typography
        htmlTag="span"
        color="black"
        fontWeight={fontWeight}
        variant={variant}
      >
        {children}
      </Typography>
    </>
  );
};

export default VersionNavigationSpan;
